import { jwtDecode } from 'jwt-decode';

export class PreemptiveRefreshError extends Error {
  constructor(message = 'preemptive-refresh-required') {
    super(message);
    this.name = 'PreemptiveRefreshError';
  }
}

export const isJwtExpiringSoon = (token: string, skewMs: number): boolean => {
  try {
    const decoded = jwtDecode<{ exp?: number }>(token);
    const exp = decoded.exp;
    if (!exp) return true; // no exp claim -> treat as expiring
    const expMs = exp * 1000;
    const now = Date.now();
    return expMs - now <= skewMs;
  } catch {
    // If token can't be decoded, do not preempt; allow normal 401/403 flow
    return false;
  }
};
